/**
 * @generated SignedSource<<a3da0e47e907938619550043a52c39ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Rows0BadPattern$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Row255BadPattern">;
  readonly " $fragmentType": "Rows0BadPattern";
};
export type Rows0BadPattern$key = {
  readonly " $data"?: Rows0BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Rows0BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Rows0BadPattern",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Row255BadPattern"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "fc9457eb1eebc53ed5b5a1ff39ac499d";

export default node;
